<script lang="ts" setup>
defineProps({
  color: {
    type: String,
    default: '#000',
  },
  width: {
    type: [String, Number],
    default: '24',
  },
  height: {
    type: [String, Number],
    default: '24',
  },
});
</script>

<template>
  <div class="animate-spin">
    <svg :width="width" :height="height" :viewBox="`0 0 24 24`" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.97" clip-path="url(#clip0_1852_34147)">
        <path d="M22.5 12C22.5 14.0767 21.8842 16.1068 20.7304 17.8335C19.5767 19.5602 17.9368 20.906 16.0182 21.7007C14.0996 22.4955 11.9884 22.7034 9.95155 22.2982C7.91475 21.8931 6.04383 20.8931 4.57538 19.4246C3.10693 17.9562 2.1069 16.0852 1.70175 14.0484C1.29661 12.0116 1.50454 9.90045 2.29926 7.98182C3.09399 6.0632 4.4398 4.42332 6.16651 3.26957C7.89323 2.11581 9.9233 1.5 12 1.5" :stroke="color" stroke-width="3" stroke-linecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_1852_34147">
          <rect width="24" height="24" fill="color" />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>
